var render = function render(){var _vm=this,_c=_vm._self._c;return _c('yt-img-shadow',{staticClass:"no-transition",staticStyle:{"background-color":"transparent"},attrs:{"height":_vm.height,"width":_vm.width,"loaded":""}},[_c('img',{staticClass:"style-scope yt-img-shadow",attrs:{"id":"img","alt":"","height":_vm.height,"width":_vm.width,"src":_vm.showImgUrl},on:{"error":_vm.onLoadError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }